const BACKSLASH_REGEXP = /\\/g;
const NULL_BYTE_REGEXP = /\0/g;

/**
 * Sanitizes a file/folder name for safe use in zip paths.
 * - Normalizes backslashes to forward slashes
 * - Replaces exact `.` and `..` segments with `_` (prevents directory traversal)
 * - Strips null bytes
 * - Removes empty segments
 */
export function sanitizePath(name: string): string {
  return name
    .replace(BACKSLASH_REGEXP, '/')
    .split('/')
    .map((seg: string): string => {
      if (seg === '.' || seg === '..') {
        return '_';
      }
      return seg.replace(NULL_BYTE_REGEXP, '');
    })
    .filter(Boolean)
    .join('/');
}
